/* 🤖 this file was generated by svg-to-ts */
export const emperorIconStore: {
  name: 'store';
  data: string;
} = {
  name: 'store',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M22.937 10.649l-3-8c-.15-.39-.52-.65-.94-.65h-14c-.42 0-.79.25-.94.649l-3 8c-.12.3-.08.65.11.92 .18.27.49.43.82.43h1v9c0 .55.44 1 1 1h16c.55 0 1-.45 1-1v-9h1c.32 0 .63-.17.82-.44 .18-.27.22-.62.11-.92Zm-2.38-.65h-2.78l-1.5-6h2.02l2.25 6Zm-12.28 0l1.5-6h1.21v6H8.26Zm4.71-6h1.21l1.5 6h-2.72v-6Zm-7.307 0H7.7l-1.5 6H3.42l2.25-6Zm8.307 16v-5h2v5h-2Zm5 0h-1v-6c0-.56-.45-1-1-1h-4c-.56 0-1 .44-1 1v6h-7v-8h14v8Z"/><path d="M7 18h3c.55 0 1-.45 1-1v-3c0-.56-.45-1-1-1H7c-.56 0-1 .44-1 1v3c0 .55.44 1 1 1Z"/></g></svg>`
};
